import { render, staticRenderFns } from "./resource.vue?vue&type=template&id=6524c243&scoped=true"
import script from "./resource.vue?vue&type=script&lang=js"
export * from "./resource.vue?vue&type=script&lang=js"
import style0 from "./resource.vue?vue&type=style&index=0&id=6524c243&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6524c243",
  null
  
)

export default component.exports